// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"389":"3258f","915":"25a4e"}[chunkId] + ".css";
};